import { z } from "zod";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchApiGet, fetchApiPut } from "./utils";

export interface Queue {
  id: number;
  name: string;
  max_concurrent: number | null;
  type: string;
  created_at: string;
}

export const UpdateQueueConcurrencyValidation = z.object({
  id: z.number().int().nonnegative(),
  max_concurrent: z.number().int().min(0).max(20).nullable(),
});

export function useListQueues() {
  const queryParams = new URLSearchParams();

  return useQuery({
    queryKey: ["system", "queues"],
    queryFn: () => fetchApiGet<Queue[]>("system/queues", queryParams),
    retry: 1,
  });
}

export function useUpdateQueueConcurrency() {
  const queryClient = useQueryClient();
  const queryParams = new URLSearchParams();

  return async (data: z.infer<typeof UpdateQueueConcurrencyValidation>) => {
    const result = await fetchApiPut<Queue>(
      `system/queues/${data.id}`,
      { max_concurrent: data.max_concurrent },
      queryParams
    );
    queryClient.invalidateQueries({ queryKey: ["system", "queues"] });
    return result;
  };
}
